import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetTrialBalanceReportExportProps {
  type: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTrialBalanceReportExport = async (type: string, filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/${type}/export?${new URLSearchParams(filter).toString()}`, {
    responseType: "blob",
  });

const useGetTrialBalanceReportExport = ({
  type,
  filter,
  queryParams,
}: UseGetTrialBalanceReportExportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["trial-balance-report-export"],
    queryFn: () => getTrialBalanceReportExport(type, filter),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTrialBalanceReportExport;
